import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createFetchableReducer, createEmptyFetchable } from 'helpers/loadableHelpers'
import { GetMeetingAction, MEETINGS_LIST_REQUEST } from 'components/features/coaching/advisorStore/actions/advisorPageActions'
import { createEmptyCollection, concatCollections, setItemInCollection, removeByKeyFromCollection } from 'helpers/normalizeHelpers'
import { CANCEL_ADVISOR_MEETING, CREATE_ADVISOR_MEETING, DELETE_ADVISOR_MEETING } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { Meeting } from 'components/features/coaching/advisorPage/types/interfaces'


const fetchableRequestReducer = createFetchableReducer<NonNullable<AdvisorDataState['meetings']['data']>>()
export const meetingsListReducer: Reducer<AdvisorDataState['meetings']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case MEETINGS_LIST_REQUEST: {
      if (action.meta !== 'success') {
        return fetchableRequestReducer(prevState, action)
      }

      const prevCollection = prevState.data ?? createEmptyCollection()
      const nextCollection = concatCollections<Meeting, 'uid'>(prevCollection, action.payload.response.meetings)

      const { errorsMap, ...restPresState } = prevState
      return {
        ...restPresState,
        isLoading: false,
        errorCode: null,
        data: nextCollection,
      }
    }

    case GetMeetingAction.type:
    case CANCEL_ADVISOR_MEETING:
    case CREATE_ADVISOR_MEETING: {
      if (action.meta !== 'success') {
        return prevState
      }

      const prevCollection = prevState.data || createEmptyCollection()

      return {
        ...prevState,
        data: setItemInCollection(prevCollection, action.payload.response.meeting, 'uid'),
      }
    }

    case DELETE_ADVISOR_MEETING: {
      if (action.meta !== 'success' || !prevState.data) {
        return prevState
      }

      return {
        ...prevState,
        data: removeByKeyFromCollection<Meeting, 'uid'>(prevState.data, action.payload.params.uid),
      }
    }

  }

  return prevState
}
